import React from 'react';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import HorseBetting from '../../components/HorseBetting/HorseBetting';
import ComingSoon from '../../components/ComingSoon/ComingSoon';

interface TradingPageProps {
  children?: React.ReactNode,
  childComponent?: string,
  includeBetslip?: boolean
}

const COMPONENTS = { HorseBetting, ComingSoon };
export default function RetailPage({ children, childComponent }: TradingPageProps) {
  const ChildComponent = COMPONENTS[childComponent];

  return (
    <div className="page">
      <Header />

      <div className="page__main page__main--retail">
        <div className="page--middle">
          <div className="page__component-wrapper">
            { ChildComponent ? <ChildComponent /> :  children }
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
